import { createSelector } from '@ngrx/store';

import { getMenuFlowDetails } from '../getMenuFlowDetails';

export const getMenuFlowPages = (menuFlowId: number, locationNo: number) =>
    createSelector(getMenuFlowDetails(menuFlowId, locationNo), (menuFlowDetails) => menuFlowDetails?.Pages?.filter((page) => page.HideFromKiosk !== true) || null);
